import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = { class: "card-header text-center" }
const _hoisted_4 = {
  href: "../../index2.html",
  class: "h1"
}
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = { class: "login-box-msg" }
const _hoisted_7 = {
  key: 1,
  class: "card-body"
}
const _hoisted_8 = { class: "login-box-msg" }
const _hoisted_9 = { class: "input-group mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-envelope" })
  ])
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "mt-3 mb-1" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("b", null, _toDisplayString(_ctx.$t("labels.tlpv")), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.system")), 1)
        ])
      ]),
      (_ctx.sended)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.passwordRecovery")), 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.sended)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.retrieveNewPassword")), 1),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event)),
                class: "form-control",
                placeholder: "Login"
              }, null, 512), [
                [_vModelText, _ctx.email]
              ]),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-block",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.forgotPassword()))
                }, _toDisplayString(_ctx.$t("buttons.requestNewPassword")), 1)
              ])
            ]),
            _createElementVNode("p", _hoisted_13, [
              _createVNode(_component_router_link, { to: "/login" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.login")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}